import * as React from "react";
import {Button as ButtonMUI, ButtonProps, withStyles} from "@material-ui/core";
import {ButtonStyle} from "@components/common/button/Button.style";

// component renders the button as another element, e.g. a span for a link that wraps in a sentence.
type IProps = ButtonProps & {component?: React.ElementType};

const Button = React.forwardRef<HTMLButtonElement, IProps>((props, ref) => {
    return (<ButtonMUI
            {...props}
            ref={ref}
            disableElevation={true}
        />);
});

export default withStyles(ButtonStyle)(Button);



// WEBPACK FOOTER //
// ./src/components/common/button/Button.tsx